import { render, staticRenderFns } from "./EducationalCategoriesFollowUpSettingsTable.vue?vue&type=template&id=bbb79ea4&"
import script from "./EducationalCategoriesFollowUpSettingsTable.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoriesFollowUpSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports